import React from 'react';
import './Separator.css';

const Separator = () => {
  return (
    <div className="section-separator">
      <div className="separator-glow"></div>
      <div className="separator-line"></div>
      <div className="separator-point"></div>
    </div>
  );
};

export default Separator;
